import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-494a6e12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-comment__control" }
const _hoisted_2 = { class: "add-comment__control--block" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Добавить ")
const _hoisted_4 = { class: "add-comment__control--wrapper" }
const _hoisted_5 = { class: "add-comment__control--block" }

import { watch, computed, ref, onMounted } from 'vue'
import {
  ElMessage,
  UploadFile,
  UploadInstance,
  UploadRawFile,
} from 'element-plus'
import { addComment } from '@/features/FAddComment/api/add.api'
import { showErrorMessage } from '@/shared/utils'
import { CommentTemplateType, ReportViewType } from '@/shared/types'
import { DocumentAdd } from '@element-plus/icons-vue'
import CommentTemplate from '@/features/FAddComment/components/CommentTemplate.vue'
import CuraproxTemplate from './components/CuraproxTemplate.vue'

interface Props {
  templates: CommentTemplateType[]
  reportType: ReportViewType
  reportId: number
}


export default /*#__PURE__*/_defineComponent({
  props: {
    templates: null,
    reportType: null,
    reportId: null
  },
  emits: ['update'],
  setup(__props: any, { emit }) {

const props = __props as {
  templates: CommentTemplateType[]
  reportType: ReportViewType
  reportId: number
}





const currentComment = ref('')
const commentTemplates = ref<CommentTemplateType[]>()
const filesUpload = ref<UploadRawFile[]>([])
const loading = ref(false)

const templates = computed(() => props.templates)

const initCommentTemplates = (): void => {
  commentTemplates.value = templates.value.filter(
    (template, index) => index < 10 ?? template
  )

  for (let id = commentTemplates.value.length; id < 10; id++) {
    const newTemplate: CommentTemplateType = {
      isVisible: false,
      template: '',
      template_id: 0,
    }

    commentTemplates.value.push(newTemplate)
  }
}

const uploadRef = ref<UploadInstance>()

const handleChangeFile = (file: UploadFile): void => {
  const typeFile = file.raw.type

  const isPDF = 'application/pdf' === typeFile
  const isPNG = 'image/png' === typeFile
  const isJPEG = 'image/jpeg' === typeFile
  const isDocs = 'application/msword' === typeFile

  const isValideFile = isPDF || isPNG || isJPEG || isDocs

  if (isValideFile) {
    filesUpload.value.push(file.raw)
  } else {
    uploadRef.value.handleRemove(file.raw)
    ElMessage({
      type: 'warning',
      message: 'Доступные типы для загрузки файлов: png, jpg, jpeg, pdf, docs',
    })
  }
}

const handleRemoveFile = (deletedFile: UploadFile): void => {
  filesUpload.value = filesUpload.value.filter(
    (file) => file.uid !== deletedFile.uid
  )
}

const handleAddComment = async (): Promise<void> => {
  loading.value = true

  const [error] = await addComment(
    props.reportType,
    props.reportId,
    currentComment.value,
    filesUpload.value
  )

  if (error) {
    showErrorMessage(error)
  } else {
    ElMessage({
      message: 'Комментарий добавлен',
      type: 'success',
    })

    currentComment.value = ''
    uploadRef.value.clearFiles()
    filesUpload.value = []

    emit('update')
  }

  loading.value = false
}

const handleOpenTemplate = (id: number): void => {
  commentTemplates.value[id - 1].isVisible = true
}

const handleInsertComment = (currentTemplate: CommentTemplateType): void => {
  const index = commentTemplates.value.findIndex(
    (commentTemplate) =>
      commentTemplate.template_id === currentTemplate.template_id
  )

  commentTemplates.value[index] = currentTemplate
  currentComment.value = currentTemplate.template
}

const handleInsertCuraproxTemplate = (templateText: string): void => {
  currentComment.value = templateText
}

const watchHandleData = computed(() => {
  return currentComment.value || filesUpload.value.length !== 0
})

watch(templates, () => {
  initCommentTemplates()
})

onMounted(() => initCommentTemplates())

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_form, { class: "add-comment" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, { class: "add-comment__input" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: currentComment.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentComment).value = $event)),
            placeholder: "Добавить комментарий",
            type: "textarea"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                disabled: !_unref(watchHandleData),
                class: "add-comment__button",
                round: "",
                type: "primary",
                onClick: handleAddComment
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_upload, {
                ref_key: "uploadRef",
                ref: uploadRef,
                "auto-upload": false,
                "on-change": handleChangeFile,
                "on-remove": handleRemoveFile,
                action: "#",
                class: "upload-demo"
              }, {
                trigger: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DocumentAdd))
                    ]),
                    _: 1
                  })
                ]),
                file: _withCtx(() => []),
                _: 1
              }, 512)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_form_item, { class: "add-comment__template" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commentTemplates.value, (template, index) => {
                  return (_openBlock(), _createBlock(_component_el_popover, {
                    visible: template.isVisible,
                    "onUpdate:visible": ($event: any) => ((template.isVisible) = $event),
                    key: template.template_id,
                    width: 500,
                    placement: "top"
                  }, {
                    reference: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        class: "add-comment__template-button",
                        round: "",
                        type: "primary",
                        onClick: ($event: any) => (handleOpenTemplate(template.template_id))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(index + 1), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(CommentTemplate, {
                        "comment-index": index + 1,
                        "comment-template": template,
                        onInsertComment: handleInsertComment
                      }, null, 8, ["comment-index", "comment-template"])
                    ]),
                    _: 2
                  }, 1032, ["visible", "onUpdate:visible"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_el_form_item, { class: "add-comment__el-form-item-curaprox" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_popover, {
                "popper-style": { backgroundColor: '#fffffff5' },
                width: 600,
                placement: "top"
              }, {
                reference: _withCtx(() => [
                  _createElementVNode("button", {
                    class: "add-comment__template-curaprox",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent","stop"]))
                  }, " Curaprox ")
                ]),
                default: _withCtx(() => [
                  _createVNode(CuraproxTemplate, { onInsertComment: handleInsertCuraproxTemplate })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  })), [
    [_directive_loading, loading.value]
  ])
}
}

})